

import React, { useState } from "react";
import { Radio, Card, Row, Col } from "antd";
import CdStatement from "./CdStatement";
import EndorsmentList from "./EndorsmentList";
import { useSelector } from "react-redux";
import { getUserData } from "../login/LoginSlice";
import "./cd.css";


const cdOptions = [
  { value: 0, label: "CD Statements", options: [
    { option: "View", optionId: 11 } 
  ]},
  { value: 1, label: "Endorsements", options: [
    { option: "View", optionId: 13 }
  ]},
];

const Index = () => {
  const [activeComponent, setActiveComponent] = useState(0); 
  const [heading, setHeading] = useState("CD Statements");
  const Data = useSelector(getUserData);


  const userModuleCD = Data?.module_data?.find((module) => module.module_id === 8); 
  const userModuleEndorsement = Data?.module_data?.find((module) => module.module_id === 9); 
  
  const userOptionIdsCD = userModuleCD?.module_option_ids || [];
  const userOptionIdsEndorsement = userModuleEndorsement?.module_option_ids || [];




  const handleComponentChange = (e) => {
    const component = e.target.value;
    setActiveComponent(component);
    setHeading(cdOptions.find((option) => option.value === component)?.label || "CD Statements");
  };

  return (
    <div>
      <Row gutter={16}>
        <Col style={{ width: "100%" }}>
          <Card
            className="cust-cd-card mb-3"
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "700",
                  fontSize: "20px",
                }}
              >
                <span className="corp-title">{heading}</span>

                <Radio.Group
                  block
                  onChange={handleComponentChange}
                  defaultValue={activeComponent}
                  buttonStyle="solid"
                  optionType="button"
                >
                  {cdOptions.map(({ value, label, options }) => (
                    <div key={value}>
                      <Radio
                        value={value}
                        disabled={
                          (value === 8 && !userOptionIdsCD.includes(11)) || 
                          (value === 9 && !userOptionIdsEndorsement.includes(13)) 
                        }
                      >
                        {label}
                      </Radio>

                     
                      {value === 8 &&
                        options.map(({ option, optionId }) => (
                          <Radio
                            key={optionId}
                            value={optionId}
                            disabled={!userOptionIdsCD.includes(optionId)}
                            style={{ marginLeft: "20px" }}
                          >
                            {option}
                          </Radio>
                        ))
                      }
                    </div>
                  ))}
                </Radio.Group>
              </div>
            }
            bordered={false}
            bodyStyle={{ padding: 0 }}
          ></Card>

     
          {activeComponent === 0 && <CdStatement />}
          {activeComponent === 1 && <EndorsmentList />}
        </Col>
      </Row>
    </div>
  );
};

export default Index;
